<template>
	<a title="Пакетное обновление данных" class="lm-dropdown-wrap">
		<button
			data-test-id="openGroupUpdate"
			class="button button-primary button__icon armlist-rmargin"
			@click="show_popup = true"
		>
			<svg width="14" height="14" fill="currentColor"  version="1.1" viewBox="165 165 420 420" xmlns="http://www.w3.org/2000/svg%22%3E" >
				<g>
					<path d="m450 583.19h-266.39c-8.168 0-14.801-6.6289-14.801-14.797v-266.39c0-8.168 6.6328-14.801 14.801-14.801h266.39c8.168 0 14.797 6.6328 14.797 14.801v266.39c0 8.168-6.6289 14.797-14.797 14.797zm-251.59-29.598h236.79v-236.79h-236.79z"/>
					<path d="m509.2 524c-8.168 0-14.801-6.6289-14.801-14.801l0.003907-251.59h-251.59c-8.1719 0-14.801-6.6289-14.801-14.797 0-8.1719 6.6289-14.801 14.801-14.801h266.39c8.168 0 14.797 6.6289 14.797 14.801v266.39c0 8.168-6.6289 14.797-14.801 14.797z"/>
					<path d="m568.39 464.8c-8.168 0-14.801-6.6289-14.801-14.801v-251.59h-251.59c-8.168 0-14.801-6.6328-14.801-14.801s6.6328-14.801 14.801-14.801h266.39c8.168 0 14.797 6.6328 14.797 14.801v266.39c0 8.168-6.6289 14.797-14.797 14.797z"/>
				</g>
			</svg>
		</button>

		<modal :visible.sync="show_popup" :upper_footer="true">
			<div slot="header" class="row d-flex group-update-data__header">
				<div class="col-md-24"><h3 class="group-update-data__title">Пакетное обновление данных на текущей странице</h3></div>
				<div class="col-md-4 d-flex jc-e">
					<button class="btn btn-default"	data-test-id="closeModal"	slot="footer"	@click="show_popup = false">
						Закрыть
					</button>
				</div>
			</div>

			<div slot="body" class="lm-dropdown">
				<p>Пакетное обновление - инструмент для массовой замены значений в полях. При нажатии на кнопку "Сохранить" все значения выбранного поля будут заменены на новые.</p>
					<div class="d-flex" v-if="!loader">
						<div class="mr-20">
							<h4>Выберите поле</h4>
							<dropdownPartials
								data-test-id="fieldList"
								:values="groupUpdateFields"
								@fieldValue="updateColumnName"
							/>
						</div>

						<div>
							<h4>{{ columnTitle }}</h4>
							<dropdownPartials
								data-test-id="fieldValue"
								v-if="fieldValues.length"
								:values="fieldValues"
								@fieldValue="updateFieldValue"
							/>
							<label v-else>
								<input v-model="updateValue" class="form-control d-input"	data-test-id="fieldValue"	type="text"/>
							</label>
						</div>

					</div>
				<div v-else class="d-flex jc-c">
					<i class="spin spin-lg " data-test-id="load_animation" />
				</div>
			</div>
			<button class="btn btn-info pull-right" data-test-id="saveGroupUpdate" slot="footer" @click="save">Сохранить</button>
		</modal>
	</a>
</template>

<script>
	import axios from "axios";
	import urlUtil from "@uarmRoot/src/util-url";

	import modal from '../../modal.vue';
	import dropdownPartials from "@uarmRoot/src/controls/partials/dropdown.vue";

	export default {
		name: 'GroupUpdateData',
		components : {
			modal, dropdownPartials
		},
		props: {
			groupUpdateFields : {
				type: Array,
				required: true,
			},
			listItems: {
				type: Array,
				required: true,
			},
			options: {
				type: Object,
			}
		},
		data: () => ({
			show_popup: false,
			loader: false,
			fieldValues: [],					   // значения для правой колонки
			columnTitle: 'columnTitle', // заголвоок у правой колонки
			selectColumnDBName: '',    // колонка из базы
			updateValue : '', 			  // Значения для обновления
		}),
		watch: {
			show_popup(){
				// при открытие модалки подставляем значения (1вое из массива)
				if (this.show_popup) {

					const firstField = this.groupUpdateFields[0];

					this.selectColumnDBName = firstField.dbcolname
					this.columnTitle = firstField.name;
					this.updateColumnName(firstField);
				}
			}
		},
		methods: {
			updateFieldValue(field) {
				this.updateValue = field.id;
			},
			updateColumnName(field) {
				this.fieldValues.length = 0;
				this.columnTitle = field.name;
				// поиск в первоначальном массиве по RANDOM_KEY
				const findField = this.groupUpdateFields.find(f => f.RANDOM_KEY === field.RANDOM_KEY);

				if (findField.ctrlCode === 'dropdown') this.fieldValues = [...findField.srv_options];

				this.selectColumnDBName = findField.dbcolname;
				this.updateValue = '';
			},
			save() { // магия
				const {id: armId} = this.options;

				const confirmSubStringList = [];
				const records = [];

				this.listItems.forEach(elUpdate => {
					confirmSubStringList.push('(ID=' + elUpdate.ITEM_ID + ')');
					records.push({
						mode: 'update',
						armId,
						primaryKeyValue: elUpdate.ITEM_ID,
						fields: [
							{
								fieldId: this.selectColumnDBName,
								value: this.updateValue
							}
							]
					});
				})

				const confirmSubString = confirmSubStringList.join(',\n');
				if (!records.length || !window.confirm('Подтвердите обновление следующих записей: \n' + confirmSubString)) {
					return;
				}

				// vm.$data.filter.wasUsed = true;

				let apiUrl = urlUtil.getDomain() + urlUtil.getPath(this.options) + this.$route.params.vpId + '/' + armId + '/data';

				// Передаем ID родительского арма - PIRS-2-10938
				if (this.$route.query.parentArmId) {
					apiUrl += `${apiUrl.indexOf('?') > -1 ? '&' : '?'}parent_arm_id=${this.$route.query.parentArmId}`;
				}

				const formData = new FormData();
				formData.append('jsonPayload', JSON.stringify({	records	}));

				this.loader = true;
				axios.post(apiUrl, formData).then((res) => {
					this.loader = false;
					if (res.data && res.data.records && res.data.records.length !== 0) {
						this.show_popup = false;

						// Успех
						this.$notify({
							type: 'success',
							text: 'Успешно обновлены записи:\n' + confirmSubString
						});

						this.$parent.$emit('update:data')

					} else {
						console.log(res);
						//TODO reject promise/
					}
				}).catch((xhr) => {
					this.loader = false
					this.show_popup = false;

					console.error(xhr);
					const srvError = xhr.response && xhr.response.data && xhr.response.data.message;

					const isConstraint = srvError && srvError.indexOf('violates foreign key constraint') !== -1;

					let isTriggerError = srvError.match(/TRIGGER_ERROR_BEGIN/) != null;

					let srvErrorStartTextError = srvError.indexOf('TRIGGER_ERROR_BEGIN') + 19;
					let srvErrorEndTextError = srvError.indexOf('TRIGGER_ERROR_END');
					let shortTextError = srvError.slice(srvErrorStartTextError, srvErrorEndTextError);

					if (isConstraint) {
						this.$notify('Данные записи невозможно обновить. Возможно, на неё ссылаются другие записи');
					} else {
						this.$notify({
							type: 'error',
							duration: -1,
							text: 'Ошибка обновления записей:\n' + confirmSubString
						});
						if (isTriggerError) {
							this.errText = shortTextError || 'Ошибка обновления';
						} else {
							this.errText = srvError || 'Ошибка обновления';
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
.jc-e{
	justify-content: flex-end;
}
.d-flex{
	display: flex;
}
.jc-c{
	justify-content: center;
}
.group-update-data__header{
	align-items: center;
	justify-content: space-between;
}
.mr-20{
	margin-right: 20px;
}
.group-update-data__title{
	margin: 0;
}
</style>
